@let statistics = elsJobStatistics();

@if (statistics?.pending) {
  <bxi-bar-loader></bxi-bar-loader>
}

@if (statistics) {
  <div class="mt-8">
    <button bx-button (click)="stopMonitoring()">
      {{ 'elsImport.stopMonitoringElsImport' | translate }}
    </button>
  </div>

  <div class="gap-xl mt-12 flex">
    <bx-badge [label]="'system.pending' | translate: { count: statistics.pending }" type="pill-outline"></bx-badge>
    <bx-badge [label]="'system.success' | translate: { count: statistics.success }" type="pill-outline"></bx-badge>
    <bx-badge [label]="'system.existing' | translate: { count: statistics.existing }" type="pill-outline"></bx-badge>
    <bx-badge
      [label]="'system.failed' | translate: { count: statistics.failed }"
      type="pill-outline"
      [color]="statistics.failed ? 'error' : 'gray'"
    ></bx-badge>
  </div>

  <div class="bg-bg-primary mt-xl grid max-h-[calc(100vh-412px)] w-full grid-cols-[auto_auto_1fr] items-center overflow-auto" role="table">
    <div class="bx-table-header">
      <div>{{ 'DevEUI' }}</div>
      <div>{{ 'system.status' | translate }}</div>
      <div>{{ 'system.error' | translate }}</div>
    </div>

    <div class="bx-table-cells">
      @for (result of statistics.importResults; track $index) {
        <div class="gap-xs flex items-baseline">
          @if (result.status === 'EXISTS' || result.status === 'CREATED') {
            <a
              class="bxi-link"
              [routerLink]="[deviceDetailsRoute]"
              [queryParams]="{ thingId: result.thingId }"
              (click)="$event.stopPropagation()"
            >
              {{ result.devEUI }}
            </a>
          } @else {
            {{ result.devEUI }}
          }
          @if (result.channel; as channel) {
            <span class="text-text-tertiary-600">{{ 'elsImport.channel' | translate: { channel } }}</span>
          }
        </div>
        <div>{{ result.status }}</div>
        <div class="overflow-hidden text-ellipsis" [title]="result.error">{{ result.error || '-' }}</div>
      }
    </div>
  </div>
}
